import { render, staticRenderFns } from "./GeneralInfoCard.vue?vue&type=template&id=fd6ea7ea&scoped=true"
import script from "./GeneralInfoCard.vue?vue&type=script&lang=js"
export * from "./GeneralInfoCard.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoCard.vue?vue&type=style&index=0&id=fd6ea7ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ea7ea",
  null
  
)

export default component.exports